
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/logged-in",
      function () {
        return require("private-next-pages/logged-in.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/logged-in"])
      });
    }
  